// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
	apiKey: "AIzaSyC5T0w0fkWbwYCS8nNwE5G6GkfeHLCeCyw",
	authDomain: "uber-eats-app-3482c.firebaseapp.com",
	projectId: "uber-eats-app-3482c",
	storageBucket: "uber-eats-app-3482c.appspot.com",
	messagingSenderId: "377233946372",
	appId: "1:377233946372:web:b77e0a43fc8a8502a3c251",
};

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);

export default firebase;
